import { AlertTriangle, TrendingDown, Users, Heart } from "lucide-react";

const PROBLEMS = [
  {
    icon: TrendingDown,
    title: "Chronic Absenteeism",
    body: "Students missing 10+ days per year are 7x more likely to drop out. Attendance is the leading indicator we keep ignoring.",
  },
  {
    icon: AlertTriangle,
    title: "Behavior & Discipline",
    body: "Referrals climb, suspensions follow, and relationships fracture. Discipline without connection is just damage control.",
  },
  {
    icon: Users,
    title: "Teacher Burnout",
    body: "44% of educators leave within 5 years. Retention isn't a salary problem alone — it's a culture problem.",
  },
  {
    icon: Heart,
    title: "Student Disengagement",
    body: "Kids don't disengage from learning. They disengage from environments that don't see them.",
  },
];

export default function Outcomes() {
  return (
    <section id="outcomes" className="relative bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="eyebrow text-gold">The Real Work</div>
            <h2 className="font-serif text-4xl sm:text-5xl text-navy mt-4 leading-[1.05] font-bold tracking-tight">
              You&apos;re not looking
              <span className="block italic font-medium">for a speaker.</span>
              You&apos;re looking for <span className="text-gold">outcomes.</span>
            </h2>
            <p className="mt-6 text-base text-navy/70 leading-relaxed max-w-md">
              Every principal, superintendent, and counselor we partner with is wrestling with the
              same four storms. We don&apos;t show up with a keynote. We show up with a plan.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {PROBLEMS.map((p, i) => (
              <div
                key={p.title}
                data-testid={`problem-card-${i}`}
                className="group bg-white border border-[hsl(var(--line))] p-7 hover:border-navy/40 transition-all duration-300 hover:-translate-y-1"
              >
                <p.icon size={22} className="text-gold" strokeWidth={1.5} />
                <h3 className="font-serif text-2xl text-navy mt-4 font-semibold">{p.title}</h3>
                <p className="mt-3 text-[14px] text-navy/65 leading-relaxed">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
